import React, { useEffect, useRef, useState } from "react";
import { FaFilePdf } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { User_Authentication } from "../../../user_authentication/User_Authentication";
import {
  Get_Pooja_Invoice_Details,
  Get_User_Booked_Pooja_List,
} from "../../../api/pooja/Pooja";
import Loader from "../../../loader/Loader";
import User_Dashbaord_Common_Section from "../../pages/user_dashboard/user_dashboard_common_section/User_Dashbaord_Common_Section";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useDispatch, useSelector } from "react-redux";
import { fetchSettingData } from "../../../redux/actions/settingAction";

export default function PoojainvoicePage() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const invoiceRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [booking, setBooking] = useState(null);

  const bookingId = Number(id);
  const { settingData } = useSelector((state) => state?.settingdata || []);

  useEffect(() => {
    dispatch(fetchSettingData());
  }, [dispatch]);

  useEffect(() => {
    const fetchBooking = async () => {
      setIsLoading(true);
      try {
        const token = User_Authentication();

        const response = await Get_Pooja_Invoice_Details(bookingId, {
          Authorization: `Bearer ${token}`,
        });

        if (response?.data?.status === 200) {
          setBooking(response?.data?.data?.pooja);
        } else {
          const listResponse = await Get_User_Booked_Pooja_List({
            Authorization: `Bearer ${token}`,
          });

          const match = listResponse?.data?.data?.pooja_list?.find(
            (item) => Number(item.id) === bookingId,
          );

          if (match) setBooking(match);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    if (bookingId) fetchBooking();
  }, [bookingId]);

  const invoice = {
    orderNo: booking?.orderNo,
    date: booking?.created_at?.slice(0, 10),
    location: booking?.location,
    poojapackage: booking?.poojapackage?.name,
    description: booking?.title,
    paymentmethod: booking?.paymentmethod,
    paymentstatus: booking?.payment_status,
    numberofpandit: booking?.poojapackage?.number_of_pandit,
    numberofday: booking?.poojapackage?.number_of_day,
    duration: booking?.poojapackage?.duration,
    total: Number(booking?.price || 0),
    poojadate: booking?.pooja_date,
  };

  const downloadInvoice = async () => {
    const input = invoiceRef.current;
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const width = pdf.internal.pageSize.getWidth();
    const height = (canvas.height * width) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, width, height);
    pdf.save(`Invoice-${invoice.orderNo}.pdf`);
  };

  return (
    <>
      <Header />

      {isLoading ? (
        <Loader />
      ) : (
        <div className="bg-gray-100 py-10">
          <div className="max-w-6xl mx-auto flex gap-6">
            <User_Dashbaord_Common_Section />

            <div className="w-full flex flex-col items-center">
              {/* INVOICE */}
              <div
                ref={invoiceRef}
                className="bg-white shadow-2xl rounded-xl p-10 w-full text-gray-800"
              >
                {/* Header */}
                <div className="flex justify-between items-start border-b pb-6">
                  <div>
                    <h1 className="text-3xl font-bold">Pooja Invoice</h1>
                    <p className="text-sm text-gray-500">
                      Thank you for your booking
                    </p>
                  </div>

                  <div className="text-right text-sm">
                    <p>
                      <b>Order No:</b> {invoice.orderNo}
                    </p>
                    <p>
                      <b>Date:</b> {invoice.date}
                    </p>
                    <p>
                      <b>Status:</b> {invoice.paymentstatus}
                    </p>
                  </div>
                </div>

                {/* Details */}
                <div className="grid grid-cols-2 gap-8 mt-6 text-sm">
                  <div>
                    <h2 className="font-semibold mb-2">Pooja Details</h2>                    
                    <p>
                      <b>Package:</b> {invoice.poojapackage}
                    </p>
                    <p>
                      <b>Location:</b> {invoice.location}
                    </p>
                  </div>

                  <div>
                    <h2 className="font-semibold mb-2">Service Info</h2>
                    <p>
                      <b>No of Pandits:</b> {invoice.numberofpandit}
                    </p>
                    <p>
                      <b>No of Days:</b> {invoice.numberofday}
                    </p>                    
                  </div>
                </div>

                {/* Table */}
                <div className="mt-8">
                  <table className="w-full border rounded-lg">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="p-3 text-left">Pooja Name</th>
                        <th className="p-3 text-center">Pooja Date</th>
                       <th className="p-3 text-right">Price</th>
                        
                        {/* <th className="p-3 text-right">Total</th> */}
                      </tr>
                    </thead>

                    <tbody>
                      <tr className="border-t">
                        <td className="p-3">{invoice.description}</td>
                        <td className="p-3 text-center">{invoice.poojadate}</td>
                        <td className="p-3 text-right">₹{invoice.total}</td>
                        {/* <td className="p-3 text-right">₹{invoice.total}</td> */}
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Summary */}
                <div className="flex justify-end mt-6">
                  <div className="w-80 space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span>Subtotal</span>
                      <span>₹{invoice.total}</span>
                    </div>

                    {/* <div className="flex justify-between">
                      <span>Payment Method</span>
                      <span>{invoice.paymentmethod}</span>
                    </div> */}

                    <div className="border-t pt-2 flex justify-between font-bold text-lg">
                      <span>Total</span>
                      <span>₹{invoice.total}</span>
                    </div>
                  </div>
                </div>

                {/* Note */}
                <div className="mt-8 bg-gray-50 p-4 rounded">
                  <p className="font-semibold">Note</p>
                  <p>Thank you for booking your pooja</p>
                </div>
              </div>

              {/* BUTTON */}
              <button
                onClick={downloadInvoice}
                className="mt-4 flex gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg"
              >
                <FaFilePdf /> Download PDF
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}
